export const toAuctionType = (val: number) => {
  switch (val) {
    case 1: return 'Premier';
    case 2: return 'Sporting & Collector';
    case 3: return 'Arms & Accessories';
    case 4: return 'Timed';
    default: return;
  }
};
